import React, { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { AuthCallbackPage } from "../../auth/session";
import { useStoreActions } from "../../store/easy-peasy/hooks";
import type { AuthSessionUser } from "../../auth/session";

const AuthCallback: React.FC = () => {
  const queryClient = useQueryClient();
  const setUserFromMe = useStoreActions((actions) => actions.setUserFromMe);

  const handleSessionReady = useCallback(
    (user: AuthSessionUser) => {
      queryClient.setQueryData(["auth", "session"], user);
      const clientId =
        user.client_id ?? user.clientId ?? user.id ?? user.user_id ?? user.userId;
      if (clientId) {
        setUserFromMe({
          id: String(clientId),
          username: user.full_name ?? user.name ?? user.email ?? "",
          email: user.email ?? "",
        });
      }
    },
    [queryClient, setUserFromMe],
  );

  return <AuthCallbackPage onSessionReady={handleSessionReady} />;
};

export default AuthCallback;
